import React, { useEffect, useState } from "react";
import {
  Checkbox,
  Tooltip,
  Box,
  Typography,
  TextField,
  IconButton,
} from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import { HistorialSolicitudFechas } from "views/Tablero/Components/Tablas";
import { ModalFormularioV2Tablero } from "components";
import serviciosTablero from "utils/serviciosTablero";

const CheckboxFecha = ({
  fechaInicio,
  fechaFin,
  tipo,
  tarjetaInfo,
  setTarjetaInfo,
  tarjeta,
  setCargando,
  setMensaje,
  solicitudActiva,
  updateData,
}) => {
  const [seleccionado, setSeleccionado] = useState(
    tarjetaInfo?.fecha_entregado === 1 ? true : false
  );
  const classesTablero = useStylesTablero();
  const [modalEditTablero, setModalEditTablero] = useState({ open: false });
  const [ctlsForm, setCtlsForm] = useState({});
  const cerrarFormTablero = () => setModalEditTablero({ open: false });

  // Función para formatear las fechas en formato "dd MMM"
  const formatearFecha = (fecha) => {
    const opciones = { day: "2-digit", month: "short" };
    return new Date(fecha).toLocaleDateString("es-ES", opciones);
  };

  // Calcular la diferencia en días entre la fecha actual y la fecha de fin
  const fechaActual = new Date();
  const fechaFinObj = new Date(fechaFin);

  // Convertir ambas fechas a la misma zona horaria para evitar errores
  const fechaActualMidnight = new Date(fechaActual.setHours(0, 0, 0, 0));
  const fechaFinMidnight = new Date(fechaFinObj.setHours(0, 0, 0, 0));

  // Calcular la diferencia en días
  const diferenciaDias = Math.ceil(
    (fechaFinMidnight - fechaActualMidnight) / (1000 * 60 * 60 * 24)
  );

  // Verificar si la fecha está próxima (dentro de 7 días) o ya pasó
  const fechaProxima = diferenciaDias <= 1 && diferenciaDias >= 0;
  const fechaPasada = diferenciaDias < 0;

  // Fecha de inicio y fin formateadas
  const fechaInicioFormateada = formatearFecha(fechaInicio);
  const fechaFinFormateada = formatearFecha(fechaFin);

  const handleMostrarHistorial = () => {
    setModalEditTablero({
      open: true,
      titulo: "Historial de solicitudes de fechas",
      Componente: HistorialSolicitudFechas,
      props: {
        setCargando: setCargando,
        idtarjeta: tarjeta,
      },
      noActions: true,
    });
  };
  // Manejar el cambio de estado del checkbox
  const marcarFechaCompleta = () => {
    setSeleccionado(!seleccionado);
    serviciosTablero.updateTituloTarjeta(
      (status, mensaje, data) => {
        setMensaje({ open: true, status: status, value: mensaje });
        if (status > 0) {
          setSeleccionado(!seleccionado);
          setTarjetaInfo({
            ...tarjetaInfo,
            fecha_entregado: !seleccionado ? 1 : 0,
          });
          let nuevaDataTarjeta = {
            ...tarjeta,
            fecha_entregado: !seleccionado ? 1 : 0,
          };
          updateData("tarjeta", nuevaDataTarjeta, tarjetaInfo.idtarjeta);
        }
      },
      setCargando,
      {
        idtarjeta: tarjetaInfo?.idtarjeta,
        fecha_entregado: !seleccionado,
      }
    );
  };

  return (
    <Box display="flex" alignItems="center">
      {!solicitudActiva && (
        <Tooltip
          title={(seleccionado ? "Desmarcar" : "Marcar") + " como completado."}
        >
          <Checkbox checked={seleccionado} onChange={marcarFechaCompleta} />
        </Tooltip>
      )}
      <TextField
        id="outlined-basic"
        variant="outlined"
        label={"Vencimiento"}
        value={`${fechaInicioFormateada} - ${fechaFinFormateada}`}
        InputProps={{
          readOnly: true,
        }}
        InputLabelProps={{
          shrink: true, // Esto asegura que el label se quede arriba incluso cuando hay un valor
        }}
        className={classesTablero.field}
      />
      {/* Mostrar un icono para ver el historial */}

      {/* Mostrar label amarillo si la fecha está próxima */}
      {fechaProxima && !seleccionado && (
        <Typography
          style={{
            backgroundColor: "#FFF9C4", // Amarillo claro
            color: "#000",
            padding: "4px 8px",
            borderRadius: "4px",
            marginLeft: "8px",
          }}
        >
          Vence pronto
        </Typography>
      )}

      {/* Mostrar label rojo si la fecha ya pasó */}
      {fechaPasada && !seleccionado && (
        <Typography
          style={{
            backgroundColor: "#FFCDD2", // Rojo claro
            color: "#D32F2F", // Texto rojo oscuro
            padding: "4px 8px",
            borderRadius: "4px",
            marginLeft: "8px",
            fontWeight: "bold",
          }}
        >
          Plazo Vencido
        </Typography>
      )}

      {/* Mostrar texto "Cumplida" si está seleccionado */}
      {seleccionado && (
        <Typography
          style={{
            backgroundColor: "#81c784", // Rojo claro
            color: "#388E3C", // Texto verde
            marginLeft: "8px",
            fontWeight: "bold",
            padding: "4px 8px",
            borderRadius: "4px",
          }}
        >
          Completada
        </Typography>
      )}
      {/* onClick={() => changeMonth(1)} */}
      <IconButton
        title="Historial de fechas"
        onClick={() => handleMostrarHistorial()}
      >
        <AccessTimeIcon style={{ color: "white" }}></AccessTimeIcon>
      </IconButton>
      <ModalFormularioV2Tablero
        open={modalEditTablero?.open || false}
        width={modalEditTablero?.width || "md"}
        titulo={modalEditTablero?.titulo || ""}
        onCerrar={cerrarFormTablero}
        noActions={modalEditTablero?.noActions || false}
        aceptar={modalEditTablero.aceptar || false}
      >
        {modalEditTablero?.Componente && (
          <modalEditTablero.Componente
            {...modalEditTablero.props}
            ctls={ctlsForm}
            setCtls={setCtlsForm}
          />
        )}
      </ModalFormularioV2Tablero>
    </Box>
  );
};

export default CheckboxFecha;
